import httpRequest from "@/utils/api";
import type {
  TenantConsoleAccount,
  TenantConsoleAccountListData,
  TenantConsoleAccountPasswordResetPayload,
  TenantConsoleAccountRole,
  TenantConsoleAccountStatus,
  TenantUserBinding,
  TenantUserBindingListData,
} from "@/types/admin/tenantConsole";

enum API {
  accounts = "/admin/tenant-console/accounts",
  accountStatus = "/admin/tenant-console/accounts/:accountId/status",
  accountPassword = "/admin/tenant-console/accounts/:accountId/password",
  bindings = "/admin/tenant-console/bindings",
  binding = "/admin/tenant-console/bindings/:bindingId",
}

export const getTenantConsoleAccountsAPI = (params: { tenantId?: number; page: number; limit: number }) => {
  return httpRequest.get<TenantConsoleAccountListData>({
    url: API.accounts,
    params: {
      tenant_id: params.tenantId,
      page: params.page,
      limit: params.limit,
    },
  });
};

export const createTenantConsoleAccountAPI = (data: {
  tenantId: number;
  loginName: string;
  displayName: string;
  password: string;
  role: TenantConsoleAccountRole;
}) => {
  return httpRequest.post<TenantConsoleAccount>({
    url: API.accounts,
    data,
  });
};

export const updateTenantConsoleAccountStatusAPI = (
  accountId: number,
  status: TenantConsoleAccountStatus,
) => {
  return httpRequest.patch<TenantConsoleAccount>({
    url: API.accountStatus.replace(":accountId", accountId.toString()),
    data: { status },
  });
};

export const resetTenantConsoleAccountPasswordAPI = (
  accountId: number,
  payload: TenantConsoleAccountPasswordResetPayload,
) => {
  return httpRequest.patch<TenantConsoleAccount>({
    url: API.accountPassword.replace(":accountId", accountId.toString()),
    data: payload,
  });
};

export const getTenantUserBindingsAPI = (params: { tenantId: number; page: number; limit: number }) => {
  return httpRequest.get<TenantUserBindingListData>({
    url: API.bindings,
    params: {
      tenant_id: params.tenantId,
      page: params.page,
      limit: params.limit,
    },
  });
};

export const createTenantUserBindingAPI = (data: { tenantId: number; userId: number }) => {
  return httpRequest.post<TenantUserBinding>({
    url: API.bindings,
    data,
  });
};

export const deleteTenantUserBindingAPI = (bindingId: number) => {
  return httpRequest.delete<void>({
    url: API.binding.replace(":bindingId", bindingId.toString()),
  });
};
